/* eslint-disable react/react-in-jsx-scope */
import { useSelector } from "react-redux";
import LogsReport from "./components/LogsReport";
import BaseCreationToken from "./components/BaseCreationToken";
import CreateUser from "./components/CreateAdminUser";
import ChangeUserPassword from "./components/UpdatePassword";
import FinancialModule from "./components/FinancialModule";
import CSManagment from "./components/CSManagment";

export default function Master() {
  const role = useSelector((state) => state.auth.role);
  return (
    <>
      {/* Alterar a permissão do modulo financeiro */}
      <FinancialModule role={role} />

      {/*  Liberar base */}
      <BaseCreationToken role={role} />

      {/* Selecionar CS */}
      <CSManagment role={role} />

      {/* Criar usuario ADM */}
      <CreateUser role={role} />

      {/* Atualizar senha usuario ADM */}
      <ChangeUserPassword role={role} />

      {/* Logs Administrativo */}
      <LogsReport role={role} />

      <footer>
        <p>.</p>
      </footer>
    </>
  );
}
